export default __webpack_public_path__ + "static/media/ic-brain-sparkle.c3e6bb08.svg";